export const GET_SOURCING_REQUESTS = "GET_SOURCING_REQUESTS";
export const UPDATE_SOURCING_REQUEST = "UPDATE_SOURCING_REQUEST";
export const DELETE_SOURCING_REQUEST = "DELETE_SOURCING_REQUEST";
